import { useEffect, useState } from 'react';
import { useApi } from '@backstage/core-plugin-api';
import {
  catalogApiRef,
  useStarredEntities,
} from '@backstage/plugin-catalog-react';
import type { Entity } from '@backstage/catalog-model';

export function useHomeStarredServices(): Entity[] {
  const catalogApi = useApi(catalogApiRef);
  const { starredEntities } = useStarredEntities();
  const [services, setServices] = useState<Entity[]>([]);

  useEffect(() => {
    let cancelled = false;
    const fetchServices = async () => {
      if (starredEntities.size === 0) {
        setServices([]);
        return;
      }
      setServices([]);
      try {
        const { items } = await catalogApi.getEntities({
          filter: { kind: ['Component', 'API', 'System'] },
        });
        const starred = items.filter(entity => {
          const entityRef = `${entity.kind.toLowerCase()}:${
            entity.metadata.namespace ?? 'default'
          }/${entity.metadata.name}`;
          return starredEntities.has(entityRef);
        });
        if (!cancelled) setServices(starred.slice(0, 4));
      } catch (error) {
        console.error('Error fetching starred services:', error);
        if (!cancelled) setServices([]);
      }
    };
    void fetchServices();
    return () => {
      cancelled = true;
    };
  }, [catalogApi, starredEntities]);

  return services;
}
